import { useEffect } from "react";
import { useMountedState } from "./useMountedState.js";
function useAsyncEffect(effect, deps) {
    const isMounted = useMountedState();
    useEffect(()=>{
        effect(isMounted);
    }, deps);
}
export { useAsyncEffect };
